import {h} from 'preact'
import { Fragment } from "react";
import { Table, Button, Tag, Space, Tooltip, Popconfirm, Grid, Typography } from "antd";
import { EditOutlined, DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import useFlowTemplates from './useFlowTemplates';

const { useBreakpoint } = Grid;

export default function FlowTemplatesTable({ onCreateFlow }) {
    const { templates, fetchTemplates, isTemplatesLoading } = useFlowTemplates();
    const screens = useBreakpoint();

    const handleDelete = (id) => {
        console.log("Delete template with ID:", id);
        //TODO: After implementing deletion, call fetchTemplates() to refresh the data
    };

    const allColumns = [
        {
            title: 'Template Name',
            dataIndex: 'template_name',
            key: 'template_name',
            width: screens.md ? undefined : "25%",
            render: (text) => <span style={{ fontWeight: 500, wordBreak: "break-word" }}>{text || "Unnamed Template"}</span>,
        },
        {
            title: 'Template ID',
            dataIndex: 'template_id',
            key: 'template_id',
            mobileHidden: true,
            render: (text) => text ? (
                <Typography.Text
                    copyable={{ text }}
                    style={{ fontFamily: "monospace", fontSize: 12, whiteSpace: "nowrap" }}
                >
                    {text}
                </Typography.Text>
            ) : '-',
        },
        {
            title: 'Services',
            key: 'services',
            render: (record) => {
                const pipeline = record.template?.pipeline || [];

                if (pipeline.length === 0) {
                    return <span>No services</span>;
                }

                return (
                    <div>
                        {pipeline.map((service, index) => {
                            let serviceName = service.service_name;
                            if(serviceName === 'esign'){
                                serviceName += "-" + service.action;
                            }
                            return (
                                <Tag color="blue" key={index} style={{ marginBottom: 4 }}>
                                    {serviceName}
                                </Tag>
                            );
                        })}
                    </div>
                );
            },
        },
        {
            title: 'Created Date',
            dataIndex: 'created_at',
            key: 'created_at',
            mobileHidden: true,
            render: (text) => {
                if (!text) return '-';
                const date = new Date(text);
                return date.toLocaleDateString();
            }
        },
        {
            title: 'Actions',
            key: 'actions',
            width: screens.md ? undefined : 80,
            render: (_, template) => (
                <Space size="middle">
                    <Button type="primary" size="small"
                            onClick={() => onCreateFlow(template)}
                    >
                        {screens.md ? "Create Flow" : "Create"}
                    </Button>
                    {/*TODO: uncomment when methods are ready*/}
                    {/*<Tooltip title="Edit">*/}
                    {/*    <Button*/}
                    {/*        type="text"*/}
                    {/*        icon={<EditOutlined />}*/}
                    {/*        size="small"*/}
                    {/*    />*/}
                    {/*</Tooltip>*/}
                    {/*<Popconfirm*/}
                    {/*    title="Delete this template?"*/}
                    {/*    description="Are you sure you want to delete this template?"*/}
                    {/*    onConfirm={() => handleDelete(record.template_id)}*/}
                    {/*    okText="Yes"*/}
                    {/*    cancelText="No"*/}
                    {/*>*/}
                    {/*    <Button*/}
                    {/*        type="text"*/}
                    {/*        icon={<DeleteOutlined />}*/}
                    {/*        size="small"*/}
                    {/*        danger*/}
                    {/*    />*/}
                    {/*</Popconfirm>*/}
                </Space>
            ),
        },
    ];

    const columns = screens.md
        ? allColumns
        : allColumns.filter(col => !col.mobileHidden);

    return (
        <div style={{ padding: '24px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16 }}>
                <div>
                    <h2 style={{ margin: 0 }}>My Flow Templates</h2>
                    <p style={{ margin: '8px 0 0 0' }}>Select a template to create a new flow or manage your existing templates.</p>
                </div>
            </div>

            <Table
                columns={columns}
                dataSource={templates}
                rowKey="template_id"
                pagination={false}
                bordered
                loading={isTemplatesLoading}
                style={{ marginTop: 16, tableLayout: "fixed" }}
            />
        </div>
    );
}